(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@makerdao/test-helpers"] = factory();
	else
		root["@makerdao/test-helpers"] = factory();
})(window, function() {
return 